export default __webpack_public_path__ + "static/media/aqi_band_1.0edca4a8.svg";